export default __webpack_public_path__ + "static/media/bg-paw.7498bdd4.png";